export const getUrl=()=>{ 
    var urlPath = window.location.href;
    if(urlPath.indexOf("localhost") !== -1) {
        return {
            baseUrl : "",
            urlRoot : "https://accorstaging.wpstaging.io/",
            googleApiUrl: "https://script.google.com/macros/s/AKfycbxKQYwf3YcGvBwxeV4RTnlFN4j-Fjt37ngupqITDjjuu58wwBBd038719XOGjwHWueRVg/exec"
        };
    } else if(window.location.host.indexOf("dev-hotelsales") !== -1) {
        return {
            baseUrl : "https://dev-hotelsales.accorplus.com",
            urlRoot : "https://accorstaging.wpstaging.io/",
            googleApiUrl: "https://script.google.com/macros/s/AKfycbxKQYwf3YcGvBwxeV4RTnlFN4j-Fjt37ngupqITDjjuu58wwBBd038719XOGjwHWueRVg/exec"
        };
    } else {
        return {
            baseUrl : "https://hotelsales.accorplus.com",
            urlRoot : "https://www.accorplus.com/",
            googleApiUrl: "https://script.google.com/macros/s/AKfycbwGi74McDnkf5UtNYZiD8VXqDvCmwPe-gOXno7sQNY9ohdBOy7ViwjxH_jv_ym2-nS8/exec"
        };
    }
}

export const getCountry = (countryCode, countryArray) => {
    for(var i = 0; i < countryArray.length; i++) {
        if(countryArray[i].indexOf(countryCode) !== -1) {
            return {"country_code" : countryArray[i]};
        }
    }
    
    return {"country_code" : "en"};
}

export const setLanguage = (region, benefitsData) => {
    console.log("setBenefits() :: region", region);
    console.log("setBenefits() :: region", benefitsData); 
    //manipulate region to fit JSON feed
   if( benefitsData ) {
        var found = false;
        for (const [key, value] of Object.entries(benefitsData)) {
                if(key.indexOf(region) > -1) {
                    found = true;
                    console.log("country found 1 :: key", key);
                    console.log("country found 1", benefitsData[key]);
                    return(value);
                }
        }
        if(!found) {
            console.log("country not found");
            return(benefitsData['au']);
        }
    }
}

export const setBenefits = (region, benefitsData) => {
    console.log("setBenefits() :: region", region);
    //manipulate region to fit JSON feed
   if( benefitsData ) {
        var found = false;
        for(var i = 0; i < benefitsData.length; i++) {
            console.log("data", benefitsData[i]);
            for(var key in benefitsData[i]) {
                console.log("key", key);
                if(key.toUpperCase().indexOf(region) > -1) {
                    found = true;
                    console.log("country found 1 :: key", key);
                    console.log("country found 1", benefitsData[i][key]);
                    return(benefitsData[i][key]);
                }
            }
        }

        if(!found) {
            console.log("country not found");
            for(var a = 0; a < benefitsData.length; a++) {
                console.log("data", benefitsData[a]);
                for(var index in benefitsData[a]) {
                    console.log("key", index);
                    if(index.indexOf("row") > -1) {
                        found = true;
                        console.log("country found 2 :: key", index);
                        console.log("country found 2", benefitsData[a].row);
                       return(benefitsData[a].row);
                    }
                }
            }
        }
    }
}

export const getFromSession = (key) => {
    return (localStorage.getItem(key));
}

// a = current and b= previous
export const getDiff = (a , b, type = null) => {
    var diff = (a < b) ? b-a : a-b;
    return diff;
}

export const isRankUp = (a , b, type = null) => {
    var rank = (a < b) ? true : false;
    console.log('tyope', type);
    if (type == 'sales'){
        return !rank;
    }
    return rank;
}

export const getBenefits = (data) => {
    console.log('region myHotelData', data)
    var benefitsProduct;
    var regionData = data === undefined ? '' : data.toLowerCase();
    switch(regionData){
        case 'id':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;
        case 'my':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;
        case 'th':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': true},
            ]
            break;   
        case 'vn':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;
        case 'sg':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;
        case 'in':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break; 
        case 'nz':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': true},
            ]
            break;
        case 'ph':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;   
        case 'hk':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;
        case 'mo': // redirected to HK
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;
        case 'cn': // redirected to HK
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;  
        case 'au':
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': true},
            ]
            break; 
        default:
            benefitsProduct = [
                {'traveller': true},
                {'explorer': true},
                {'discovery': false},
            ]
            break;
    }

    return benefitsProduct;
}

export const getDifferenceInDays = (date1, date2) => {
    return Math.floor((Math.abs(date2-date1))/(1000*60*60*24));
}

export const isProd=()=>{ 
    var urlPath = window.location.href;
    if(urlPath.indexOf("localhost") !== -1) {
        return false;
    } else if(window.location.host.indexOf("dev-hotelsales") !== -1) {
        return false;
    } else {
        return true;
    }
}

/**
 * This a helper based from native .sort() in js which will sort items https://en.wikipedia.org/wiki/In-place_algorithm.
 * @param {Array<T>} data
 * Accepts an array to be sorted.
 * @param {string} key
 * Optional parameters to sort an array of object based on key
 * @returns
 */
export const tailorSort = (data, key) => {
    if (!data) {
      throw new Error("No data present.");
    };

    const churner = (dataA, dataB) => {
      if (typeof dataA === "number" && typeof dataB === "number") {
        return dataA - dataB;
      }
      if (typeof dataA === "number") {
        return -1;
      }
      if (typeof dataB === "number") {
        return 1;
      } else {
        return dataA?.localeCompare(dataB, {
          ignorePunctuation: true,
        });
      }
    };
  
    if (!key) {
      return data.sort((dataA, dataB) => churner(dataA, dataB));
    }
  
    return data.sort((dataA, dataB) => churner(dataA?.[key], dataB?.[key]));
  };
  